import { BehaviorSubject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { IInventoryItemWithCategory } from '@inventory/models/inventory';
import { SearchControlComponent } from '@shared/components/forms/search-control/search-control.component';
import { SwitchControlComponent } from '@shared/components/forms/switch-control/switch-control.component';
import { LoadingStateComponent } from '@shared/components/loading-state/loading-state.component';
import { NullDefaultPipe } from '@shared/pipes/null-default.pipe';

@Component({
	selector: 'app-mobile-inventory-table',
	imports: [CommonModule, ReactiveFormsModule, SearchControlComponent, SwitchControlComponent, LoadingStateComponent, NullDefaultPipe],
	templateUrl: './mobile-inventory-table.component.html',
	styleUrl: './mobile-inventory-table.component.scss',
	host: {
		class: 'h-100',
	},
})
export class MobileInventoryTableComponent implements OnInit, OnDestroy {
	@Input() isLoading: boolean;
	@Input() inventoryItems: Array<IInventoryItemWithCategory>;
	@Input() searchTerm$: BehaviorSubject<string>;
	@Input() showArchived$: BehaviorSubject<boolean>;
	@Output() inventoryItemEdit = new EventEmitter<IInventoryItemWithCategory>();
	@Output() inventoryItemManage = new EventEmitter<IInventoryItemWithCategory>();
	@Output() inventoryItemArchive = new EventEmitter<IInventoryItemWithCategory>();
	@Output() inventoryItemUnarchive = new EventEmitter<IInventoryItemWithCategory>();
	@Output() addNewEvent = new EventEmitter<void>();

	form: FormGroup<{ showArchived: FormControl }>;
	searchControl = new FormControl('', { nonNullable: true });

	destroyed$ = new EventEmitter<void>();

	get showArchived(): FormControl<boolean> {
		return this.form.controls.showArchived;
	}

	ngOnInit(): void {
		this.form = new FormGroup({
			showArchived: new FormControl<boolean>(false),
		});

		this.searchControl.valueChanges.pipe(takeUntil(this.destroyed$), debounceTime(500), distinctUntilChanged()).subscribe((value) => {
			this.searchTerm$.next(value);
		});
		this.showArchived.valueChanges.pipe(takeUntil(this.destroyed$), distinctUntilChanged()).subscribe((value) => {
			this.showArchived$.next(value);
		});
	}

	ngOnDestroy(): void {
		this.destroyed$.emit();
	}

	onInventoryItemEdit(item: IInventoryItemWithCategory) {
		this.inventoryItemEdit.emit(item);
	}

	onInventoryItemManage(item: IInventoryItemWithCategory) {
		this.inventoryItemManage.emit(item);
	}

	onInventoryItemArchive(item: IInventoryItemWithCategory) {
		this.inventoryItemArchive.emit(item);
	}

	onInventoryItemUnarchive(item: IInventoryItemWithCategory) {
		this.inventoryItemUnarchive.emit(item);
	}

	onAddNewClick() {
		this.addNewEvent.emit();
	}
}
